// MARK://dhk8/admin-shell/lib/queries/roles
// Roles del tenant (#3 F4) por el grafo (platform-auth, tenant del JWT). `roles`
// devuelve built-ins sintéticos (builtin:true, NO editables) + roles custom del
// tenant (builtin:false). Las mutations (crear/editar/borrar) son acciones de
// AUTORIDAD — gating server-side (platform-auth:role:{read,create,update,delete}@*);
// el backend rechaza mutar built-ins. `modules` son claves canónicas de módulo
// (@dockethub/contracts ModuleKey) que el rol deja VER.
import { graphql } from '../../gql/index.js'

export const RolesQuery = graphql(`
  query Roles {
    roles {
      id
      name
      description
      modules
      builtin
    }
  }
`)

export const CreateRoleMutation = graphql(`
  mutation CreateRole($input: CreateRoleInput!) {
    createRole(input: $input) {
      id
      name
      description
      modules
      builtin
    }
  }
`)

export const UpdateRoleMutation = graphql(`
  mutation UpdateRole($id: ID!, $input: UpdateRoleInput!) {
    updateRole(id: $id, input: $input) {
      id
      name
      description
      modules
      builtin
    }
  }
`)

export const DeleteRoleMutation = graphql(`
  mutation DeleteRole($id: ID!) {
    deleteRole(id: $id)
  }
`)
